var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStockReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h79.5v27H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 268,
    height: 260,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 -14)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h228a8 8 0 0 1 8 8v228H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h228a7.5 7.5 0 0 1 7.5 7.5v227.5h-243V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0h228a8 8 0 0 1 8 8v16H0V8a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 .5h228a7.5 7.5 0 0 1 7.5 7.5v15.5H.5V8A7.5 7.5 0 0 1 8 .5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37",
    transform: "translate(10 9)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(16)",
    fill: "#00c243"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23h244v20H0z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.5 23.5h243v19H.5z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 148",
    d: "M29 31h8a2 2 0 0 1 0 4h-8a2 2 0 0 1 0-4Z",
    fill: "#fd0826"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(43 31)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(59 31)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(75 31)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(91 31)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(107 31)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(123 31)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(139 31)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(155 31)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(171 31)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(187 31)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(203 31)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1247",
    transform: "translate(-294 -1918)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1527",
    fill: "#fff",
    d: "M306 1969h221v83H306z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 23",
    width: 82,
    height: 6,
    rx: 1,
    transform: "translate(315 1980)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 12,
    height: 4,
    rx: 1,
    transform: "translate(401 1982)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1528",
    width: 18,
    height: 4,
    rx: 1,
    transform: "translate(417 1982)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1244"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1243",
    transform: "translate(-2 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1535",
    width: 25,
    height: 6,
    rx: 1,
    transform: "translate(407 1994)",
    fill: "#fd0826",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1536",
    width: 12,
    height: 4,
    rx: 1,
    transform: "translate(420 2002)",
    fill: "#9098a4",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1240"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 150",
    d: "M314.771 2025.748h111.694l-2.437 4.553h-2.581l-2-1.754-2.858-5.464-6.064 5.464h-10.077l-5.841 7.623-4.222-1.5-7.423 2.48-8.829-2.48-9.442-15.355-26.009 17.835-5.133-4.976-3.135 2.5-5.657-11.59-4.974 7.219Z",
    fill: "#ffc1c8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 152",
    d: "M323.489 2025.653h2.04l-.819-1.8Z",
    fill: "#a6d879"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 149",
    d: "m314.771 2025.7 5.008 4.58 4.982-7.42 5.5 11.421 3.027-2.568 5.555 5.536 25.562-18.11 9.59 15.143 9.029 2.968 7.412-2.968 4.151 1.6 6.077-7.736h9.732l6.255-5.285 2.591 5.285 1.971 2.135h2.326l2.984-4.58h3.45",
    fill: "none",
    stroke: "#fd0826",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 151",
    d: "m322.939 2025.653 1.7-2.9 1.5 2.9",
    fill: "none",
    stroke: "#00c243"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 153",
    d: "M356.1 2025.653h11.889l-3.7-5.693Z",
    fill: "#a6d879"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 154",
    d: "m355.012 2025.653 9.368-6.462 4.146 6.462",
    fill: "none",
    stroke: "#00c243"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 155",
    d: "m414 2025.653 2.69-1.976 1.292 1.976Z",
    fill: "#a6d879"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 156",
    d: "m413.172 2025.653 3.524-2.591 1.419 2.591",
    fill: "none",
    stroke: "#00c243"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1242"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1239",
    transform: "translate(-7 20)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1529",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(447 1981)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1530",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(463 1981)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1531",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(479 1981)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1532",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(495 1981)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 12",
    transform: "translate(440 2009)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1241",
    transform: "translate(-441 -1996)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 25,
    height: 4,
    rx: 1,
    transform: "translate(441 1999)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1533",
    width: 23,
    height: 4,
    rx: 1,
    transform: "translate(470 1999)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1534",
    width: 23,
    height: 4,
    rx: 1,
    transform: "translate(497 1999)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#c7cbd1",
    d: "M441.5 1996.5h79"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1241",
    transform: "translate(-441 -1987)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 25,
    height: 4,
    rx: 1,
    transform: "translate(441 1999)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1533",
    width: 23,
    height: 4,
    rx: 1,
    transform: "translate(470 1999)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1534",
    width: 23,
    height: 4,
    rx: 1,
    transform: "translate(497 1999)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#c7cbd1",
    d: "M441.5 1996.5h79"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1241",
    transform: "translate(-441 -1978)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 25,
    height: 4,
    rx: 1,
    transform: "translate(441 1999)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1533",
    width: 23,
    height: 4,
    rx: 1,
    transform: "translate(470 1999)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1534",
    width: 23,
    height: 4,
    rx: 1,
    transform: "translate(497 1999)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    fill: "none",
    stroke: "#c7cbd1",
    d: "M441.5 1996.5h79"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1248",
    transform: "translate(-294 -1926)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1537",
    fill: "#fff",
    d: "M306 2068h221v73H306z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1538",
    width: 62,
    height: 6,
    rx: 1,
    transform: "translate(315 2076)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1245",
    transform: "translate(-65 96)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1529",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(447 1981)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1530",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(463 1981)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1531",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(479 1981)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1246",
    transform: "translate(79.576 565)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1501",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(314.424 1532)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1207",
    transform: "translate(314 1540)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 126,
    height: 4,
    rx: 1,
    transform: "translate(.424)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 126,
    height: 4,
    rx: 1,
    transform: "translate(.424 7)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 126,
    height: 4,
    rx: 1,
    transform: "translate(.424 14)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 126,
    height: 4,
    rx: 1,
    transform: "translate(.424 21)",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m338.245 2114.724-4.024 2.115.769-4.484-3.256-3.17 4.5-.654 2.011-4.076 2.012 4.077 4.5.654-3.257 3.169.769 4.481Z",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "star-full",
    d: "m353.755 2114.724-4.024 2.115.769-4.484-3.256-3.17 4.5-.654 2.011-4.076 2.012 4.077 4.5.654-3.257 3.169.769 4.481Z",
    fill: "#9098a4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockReport);
export default __webpack_public_path__ + "static/media/stock-report.4a174ce66d568f0871418c7d2960aac5.svg";
export { ForwardRef as ReactComponent };